import React from 'react';
import classNames from 'classnames';
import { RESPONSIVE_GRID } from '../../constants/cmsResourceTypes';
import CmsComponentGrid from '../../components/CmsComponentGrid';
import styles from './index.module.scss';
const ResponsiveGrid = ({ childComponents, cqResponsive, position, preloadImages = false, }) => (React.createElement("div", { className: classNames(styles.grid) },
    React.createElement(CmsComponentGrid, { childComponents: childComponents, cqResponsive: cqResponsive, position: position, preloadImages: preloadImages })));
ResponsiveGrid.resourceType = RESPONSIVE_GRID;
export default ResponsiveGrid;
//# sourceMappingURL=index.js.map